import { render, staticRenderFns } from "./ElementProperties.vue?vue&type=template&id=63a261fb&"
import script from "./ElementProperties.vue?vue&type=script&lang=js&"
export * from "./ElementProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-sub-design\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a261fb')) {
      api.createRecord('63a261fb', component.options)
    } else {
      api.reload('63a261fb', component.options)
    }
    module.hot.accept("./ElementProperties.vue?vue&type=template&id=63a261fb&", function () {
      api.rerender('63a261fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bpmnProcessDesigner/package/penal/properties/ElementProperties.vue"
export default component.exports